// Real image URLs scraped from bookmystudiospace.com
export const siteImages = {
  // Slider/hero images
  heroSlider1: "https://bookmystudiospace.com/wp-content/uploads/2021/03/Slider.jpg",
  heroSlider2: "https://bookmystudiospace.com/wp-content/uploads/2021/04/Slider2.jpg",

  // Logo
  logo: "https://bookmystudiospace.com/wp-content/uploads/2021/03/MyStudio_Logo_Studio.png",

  // Service icons
  serviceIcon1: "https://bookmystudiospace.com/wp-content/uploads/2018/06/about-icon-1.png",
  serviceIcon2: "https://bookmystudiospace.com/wp-content/uploads/2018/06/hp-service-icon-2.png",
  editingIcon: "https://bookmystudiospace.com/wp-content/uploads/2021/05/editing-icon.png",

  // Portfolio / Gallery
  portfolioBW1: "https://bookmystudiospace.com/wp-content/uploads/2021/05/Portfolio-BW-1-600x800.jpg",
  portfolioBW5: "https://bookmystudiospace.com/wp-content/uploads/2021/05/Portfolio-BW-5-600x800.jpg",
  portfolioBW6: "https://bookmystudiospace.com/wp-content/uploads/2021/05/Portfolio-BW-6-1-600x800.jpg",
  portfolioBirthdays: "https://bookmystudiospace.com/wp-content/uploads/2021/04/MyStudio_Portfolio-Birthdays-600x800.jpg",
  portfolioOutside: "https://bookmystudiospace.com/wp-content/uploads/2021/04/MyStudio_Portfolio-OutsideStudio-600x800.jpg",

  // Team member headshots
  cedric: "https://bookmystudiospace.com/wp-content/uploads/2016/05/Personnel-Cedric-700x853.jpg",
  tabitha: "https://bookmystudiospace.com/wp-content/uploads/2022/04/tab-editorial-1-700x935.jpg",
  pentaxxGuy: "https://bookmystudiospace.com/wp-content/uploads/2022/04/pentaxx-guy-102-700x935.jpg",
  gary: "https://bookmystudiospace.com/wp-content/uploads/2016/05/gary-700x853.jpg",
  rachael: "https://bookmystudiospace.com/wp-content/uploads/2016/05/rach-banks-web-1-700x853.jpg",
  deontae: "https://bookmystudiospace.com/wp-content/uploads/2016/05/deontae-700x853.jpg",

  // Facilities
  studioAid: "https://bookmystudiospace.com/wp-content/uploads/2021/09/Studio_Aid-1-1-700x450.jpg",
  studioProp: "https://bookmystudiospace.com/wp-content/uploads/2021/09/Studio_Prop-1.jpg",
  studioSet: "https://bookmystudiospace.com/wp-content/uploads/2021/09/Studio_Set-1-700x450.jpg",
  consultationImage: "https://bookmystudiospace.com/wp-content/uploads/2021/10/Additional-Info-Homepage-Bordered.jpg",

  // Blog post hero images
  blogPersonalBrand: "https://bookmystudiospace.com/wp-content/uploads/2016/05/Personnel-Cedric-700x450.jpg",
  blogCommercial: "https://bookmystudiospace.com/wp-content/uploads/2021/05/Portfolio-BW-3-700x450.jpg",
  blogShortFilm: "https://bookmystudiospace.com/wp-content/uploads/2018/06/pexels-photo-38196-700x450.jpeg",

  // Brand logos
  sonyLogo: "https://bookmystudiospace.com/wp-content/uploads/2021/09/sony-logo-1.png",
  canonLogo: "https://bookmystudiospace.com/wp-content/uploads/2021/09/canon-logo-1.png",
  lumixLogo: "https://bookmystudiospace.com/wp-content/uploads/2021/09/lumix-logo.png",
  blackmagicLogo: "https://bookmystudiospace.com/wp-content/uploads/2021/09/Blackmagic_Design_logo-1.png",
  savageLogo: "https://bookmystudiospace.com/wp-content/uploads/2021/09/savage-logo.png",
};

// Real social media links
export const socialLinks = {
  facebook: "http://facebook.com/MyStudioColumbus/",
  instagram: "http://instagram.com/mystudiocolumbus",
  pinterest: "https://www.pinterest.com/bookmystudiospace",
  twitter: "https://twitter.com/mystudiocolga",
  youtube: "https://www.youtube.com/channel/UCbbSEavVQWrDLtWGgn7p4-g/featured",
  linkedin: "http://linkedin.com/company/mystudiocolumbus",
};
